import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {container} from "@Container";
import {TYPES} from "@Types";
import {ArmyListUnitView} from "@Selectors/builder/myArmyList/make/view/ArmyListUnitView";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import { UserFavoriteUnitsAction } from '@Redux/actions/ninthAge/user-favorite-units.action';
import armyListUnitSlice from '@Redux/reducers/builder/armyListUnit.slice';

interface IArmyListUnitDeleteProps {
  armyListUnit: ArmyListUnitView
}

const ArmyListUnitFavoriteComponent: React.FC<ArmyListUnitDeleteProps> = ({armyListUnit, cancel, toFavorite}) => {
  const [name, setName] = React.useState(armyListUnit.name);

  const checkName = () => {
    return name && name.length > 0;
  }

  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage {...defaultMessages.armyListUnitFavoriteFormTitle} /></h1>
      <p><FormattedMessage {...defaultMessages.armyListUnitFavoriteFormAction} /> <strong>{armyListUnit.name}</strong> ?</p>
      <div className="form-group row m-2 ms-4 me-4">
        <label htmlFor="name" className="col-sm-2 col-form-label">Name*</label>
        <div className="col-sm-10">
          <input type="text" className="form-control" id="name" value={name} onChange={(e) => setName(e.target.value)} />
          {!checkName() && <small className="text-danger">Name is required</small>}
        </div>
      </div>
      <p><FormattedMessage {...defaultMessages.armyListUnitFavoriteFormDescription} /></p>
      <div className="action">
        <button className="btn btn-age" type="button" onClick={() => cancel()}>
          <FormattedMessage {...defaultMessages.formCancel} /></button>
        <button className="btn btn-age" type="button" onClick={() => toFavorite(armyListUnit, name)}>
          <i className="fa fa-trash" aria-hidden="true" /> <FormattedMessage {...defaultMessages.formCreate} />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (_: AppState, owsProps: IArmyListUnitDeleteProps) => ({
  armyListUnit: owsProps.armyListUnit
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const favoriteUnitAction = container.get<UserFavoriteUnitsAction>(TYPES.Actions.NinthAge.FavoriteUnit.UserFavoriteUnitsAction);
  return {
    toFavorite: (armyListUnit: ArmyListUnitView, name: string) => {
      if(!name || name === '')
        return;
      dispatch(favoriteUnitAction.create(armyListUnit.item, name))
    },
    cancel: () => dispatch(armyListUnitSlice.actions.cancel())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListUnitFavoriteComponent);

type ArmyListUnitDeleteProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
